import { FEATURES } from '../constants';
import { AppFeature } from '../enum';

export const hasFeatureEnabled = (feature?: AppFeature) =>
  feature ? FEATURES.includes(feature) : true;
